import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";


const BackToTop = ({ observeRef}) => {

  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // smooth scrolling
    });
  };

  useEffect(() => {
    if (!observeRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Show button when element is NOT visible
        setIsVisible(entry.isIntersecting);
      },
      {
        root: null,   // viewport
        threshold: 0, // trigger when even 1px is visible
      }
    );

    observer.observe(observeRef.current);

    return () => observer.disconnect();

  }, [observeRef]);

  return (
    <>
        {isVisible && (
            <button
            onClick={scrollToTop}
            className={`fixed bottom-8 right-8 p-3 rounded-full bg-[#251E5C] text-white shadow transition-opacity duration-300 ${
    isVisible ? "opacity-100" : "opacity-0"}`}>
              <FaArrowUp />
            </button>
        )}
    </>
  );
};

export default BackToTop;